import { render, staticRenderFns } from "./supplier-invoice.vue?vue&type=template&id=0ca41c52"
import script from "./supplier-invoice.vue?vue&type=script&lang=js"
export * from "./supplier-invoice.vue?vue&type=script&lang=js"
import style0 from "./supplier-invoice.vue?vue&type=style&index=0&id=0ca41c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports